import { Injectable } from '@angular/core';
import {MetodosServicio} from '../../../../_helpers/interfaces/metodos-servicio';
import {VentasComercio} from '../../../../_models/ventas-comercio';
import {HttpClient} from '@angular/common/http';
import {SettingsService} from '../../../../services/settings.service';
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class VentasComercioService extends MetodosServicio<VentasComercio> {

  constructor(
    public http: HttpClient,
    private settings: SettingsService
  ) {
    super(http, 'procesadora/ventas', VentasComercio);
  }

  restartItem(): void {
    this.setItem(new VentasComercio());
  }


  obtenerListaComercio(cantidad = 20): Observable<any> {
    return this.http.get(this.settings.URL_BASE + 'public/comercio' + (cantidad ? '?cantidad=' + cantidad : ''));
  }

  obtenerListaVenta(filtro: any) {
    return this.http.post(this.settings.URL_BASE + 'fraccionate/procesadora/ventas', filtro);
  }

  obtenerListaVentaExportar(filtro: any) {
    return this.http.post(this.settings.URL_BASE + 'reporte/fraccionate/ventas', filtro);
  }
}
